import React from "react";
import { ShieldAlert } from 'lucide-react';
import { NavItem } from "../NavItem";

export function RecentViolationsLink({ isCollapsed }) {
    return (
        <NavItem
            redirectUrl="/recentviolations"
            Icon={ShieldAlert}
            label="Recent Violations"
            isCollapsed={isCollapsed}
        />
    );
}